module.exports = __webpack_public_path__ + "img/cursos.b2f448f9.svg";